<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>THESES.TITLE</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>

  <div class="no-entries-label" translate>THESES.UNDER_CONSTRUCTION</div>

</ion-content>
